import { defineMessages } from 'react-intl';

export const legalHintsImageMessages = defineMessages({
  alt: {
    id: 'legalHintsImage.alt',
    defaultMessage: 'Let op! Geld lenen kost geld',
  },
});
